import * as React from 'react';
import { observer } from 'mobx-react';
import { func, string, array } from 'prop-types';
import { log } from '@execonline-inc/logging';

/**
 * QuickSight embedding uses the AWS QuickSight Embedding SDK
 */
class QuickSightVisualizationEmbed extends React.Component {
  quickSightEmbedRef = React.createRef();
  dashboard;
  visualization;

  getOptions() {
    return {
      width: '100%',
      height: this.props.height,
      parameters: this.props.parameters || [],
      onSuccess: (dashboardExperience) => {
        log('QuickSight dashboard loaded successfully');
        this.dashboard = dashboardExperience;

        // Set up event listeners for tab and filter changes
        if (this.props.onTabChange) {
          dashboardExperience.on('SHEET_CHANGED', (event) => {
            log('QuickSight tab changed:', event.sheet?.sheetId);
            this.props.onTabChange(event.sheet?.sheetId);
          });
        }

        if (this.props.onFiltersChange) {
          dashboardExperience.on('PARAMETERS_CHANGED', (event) => {
            log('QuickSight parameters changed:', event.parameters);
            this.props.onFiltersChange(event.parameters);
          });
        }

        // Call the parent onReady callback
        this.props.onReady();

        // Call onDashboardReady with the dashboard experience if provided
        if (this.props.onDashboardReady) {
          this.props.onDashboardReady(dashboardExperience);
        }
      },
      onError: (error) => {
        log('QuickSight embed error:', error);
      },
    };
  }

  componentDidMount() {
    log('Loading QuickSight visualization', this.props.visualizationPath);
    if (this.quickSightEmbedRef.current) {
      // The visualizationToken for QuickSight will be the entire embed URL
      // returned from the server, which contains the necessary session
      this.visualization = this.props.vizFn(
        this.quickSightEmbedRef.current,
        this.props.visualizationToken,
        this.getOptions(),
      );
    }
  }

  getDashboard() {
    return this.dashboard;
  }

  render() {
    return (
      <div className="max-w-clientPortalMaxWidth mx-auto lg:px-12">
        <div ref={this.quickSightEmbedRef} />
      </div>
    );
  }
}

QuickSightVisualizationEmbed.propTypes = {
  vizFn: func.isRequired,
  visualizationPath: string.isRequired,
  visualizationToken: string.isRequired,
  height: string.isRequired,
  width: string.isRequired,
  onReady: func.isRequired,
  onDashboardReady: func,
  onTabChange: func,
  onFiltersChange: func,
  parameters: array,
};

export default observer(QuickSightVisualizationEmbed);
